import { render, staticRenderFns } from "./RentDetail.vue?vue&type=template&id=86964dcc&scoped=true&"
import script from "./RentDetail.vue?vue&type=script&lang=js&"
export * from "./RentDetail.vue?vue&type=script&lang=js&"
import style0 from "./RentDetail.vue?vue&type=style&index=0&id=86964dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86964dcc",
  null
  
)

export default component.exports